import {Stack} from "@mui/material";

interface StackCardProps {
    children: React.ReactNode;
}

const StackCard: React.FC<StackCardProps> = ({children}) => {
    return (
            <Stack
                    spacing={2}
                    sx={{
                        maxWidth: 400,
                        background: `white`,
                        padding: `26px`,
                        borderRadius: `12px`,
                        boxShadow: `0 4px 6px rgba(0, 0, 0, 0.02),
                                    0 10px 24px rgba(0, 0, 0, 0.06),
                                    0 0 0 1px rgba(0, 0, 0, 0.02);`,
                        width: "100%"
                    }}
                    justifyContent={'center'}
            >
                {children}
            </Stack>
    )
}
export default StackCard;